<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="6" lg="4">
        <v-card class="pa-8 text-center">
          <v-icon color="warning" size="64" class="mb-4">
            mdi-file-question
          </v-icon>
          
          <v-card-title class="text-h5 mb-2 text-center">
            404
          </v-card-title>
          
          <v-card-subtitle class="text-h6 mb-4 text-center">
            Страница не найдена
          </v-card-subtitle>
          
          <v-card-text class="text-body-1 mb-4">
            Запрашиваемая страница не существует или была перемещена. 
            Проверьте правильность URL-адреса или перейдите на главную страницу.
          </v-card-text>
          
          <v-btn
            color="primary"
            size="large"
            variant="elevated"
            :to="homePath"
            block
          >
            {{ homeButtonText }}
          </v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'PageNotFound',
  computed: {
    ...mapState(['isLoggedIn']),
    homePath() {
      return this.isLoggedIn ? '/dashboard' : '/';
    },
    homeButtonText() {
      return this.isLoggedIn ? 'К панели управления' : 'На главную';
    }
  }
};
</script>

<style scoped>
/* Vuetify handles styling, minimal custom styles needed */
</style>
